import React from "react";
import { NavLink } from "react-router-dom";
import qs from "qs";

export default class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props["res"] };
    // console.log(this.props.res);
  }

  render() {
    // console.log("Inside Result", this.state);
    let params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    try {
      params['version'] = params['version'].split('.').join('');
      params['device'] = params['device'].toLowerCase();
    } catch (e) {
      console.log(e.message);
    }

    let teamAScore = [];
    let teamBScore = [];
    let teamA = [];
    let teamB = "";
    try {
      teamA = this.props.res.teama;
      teamAScore = teamA.scores.split("&");
      teamA["teamAScore"] = teamAScore;
      console.log(teamA);
    } catch (e) { }
    try {
      teamB = this.props.res.teamb;
      teamBScore = teamB.scores.split("&");
      teamB["teamBScore"] = teamBScore;
    } catch (e) { }
    let innings = this.props.res.innings;
    let matchtitle = this.state.status_note;
    try {
      matchtitle = matchtitle.replace(/ *\([^)]*\) */g, "");
    } catch (e) { }
    // console.log("teama>>",this.state.teama);
    // console.log("teamA>>",teamA);
    return (
      <div>
        <div className="sports_widget_container">
          <div className="sports_widget_section">
            <div className="sports_widget_wrapp">
              <div className="widget_top_section">
                <h6
                  className="center widget_top_title"
                  style={{ textTransform: "uppercase" }}
                >
                  {this.state.competition.title
                    ? this.state.competition.title
                    : "IPL 2019"}
                </h6>
                <div className="line_all_center">
                  <div className="horizline_center" />
                </div>
                <h4 className="matchBetwen">{matchtitle}</h4>
              </div>
              <div className="pos_rel">
                <h5 className="vs">vs</h5>
                {this.props.res.format != 2 ? (
                  <div>
                    <div className="widget_body_section">
                      {this.state.teama ? (
                        <div className="widget_body_column_left ">
                          <div className="flex_column ">
                            <h4 className="bluebold16">
                              {this.state.teama.name
                                ? this.state.teama.name
                                : this.state.teama.short_name}
                            </h4>
                          </div>
                        </div>
                      ) : null}

                      <div className="widget_body_column_right ">
                        <div className="justify_center ">
                          <h4 className="whitesemi16">
                            {this.state.teama.scores_full}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div className="verticle_hr" />
                    <div className="widget_body_section">
                      {this.state.teamb ? (
                        <div className="widget_body_column_left ">
                          <div className="flex_column ">
                            <h4 className="bluebold16 text_green">
                              {this.state.teamb.name
                                ? this.state.teamb.name
                                : this.state.teamb.short_name}
                            </h4>
                          </div>
                        </div>
                      ) : null}

                      <div className="widget_body_column_right ">
                        <div className="justify_center ">
                          <h4 className="whitesemi16">
                            {this.state.teamb.scores_full}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                    <div>
                      {teamA ? (
                        <div className="">
                          <div className="widget_body_column_new ">
                            <div className="flex_col alignstart_complete">
                              <h4 className="blueEboldnew16 ">{teamA.short_name}</h4>
                            </div>
                            {teamA["teamAScore"] ? (
                              <div className="flex_col aligncenter">
                                {teamA["teamAScore"][0] ? (
                                  <h4 className="whitesemi16">1st Inning</h4>
                                ) : (
                                    ""
                                  )}
                                {teamA["teamAScore"][1] ? (
                                  <h4 className="whitesemi16">2st Inning</h4>
                                ) : (
                                    ""
                                  )}
                              </div>
                            ) : (
                                ""
                              )}
                            {teamA["teamAScore"] ? (
                              <div className="flex_col alignright_complete">
                                {teamA["teamAScore"][0] ? (
                                  <h4 className="blueblacknew16 ">
                                    {teamA["teamAScore"][0]}
                                  </h4>
                                ) : (
                                    ""
                                  )}
                                {teamA["teamAScore"][1] ? (
                                  <h4 className="blueblacknew16 ">
                                    {teamA["teamAScore"][1]}
                                  </h4>
                                ) : (
                                    ""
                                  )}
                              </div>
                            ) : (
                                ""
                              )}
                          </div>
                        </div>
                      ) : (
                          ""
                        )}

                      <div className="verticle_hr" />
                      <div className="">
                        <div className="widget_body_column_new ">
                          <div className="flex_col alignstart_complete">
                            <h4 className="blueEboldnew16 text_green">
                              {teamB.name}
                            </h4>
                          </div>
                          {teamB["teamBScore"] ? (
                            <div className="flex_col aligncenter">
                              {teamB["teamBScore"][0] ? (
                                <h4 className="whitesemi16">1st Inning</h4>
                              ) : (
                                  ""
                                )}
                              {teamB["teamBScore"][1] ? (
                                <h4 className="whitesemi16">2st Inning</h4>
                              ) : (
                                  ""
                                )}
                            </div>
                          ) : (
                              ""
                            )}

                          {teamB["teamBScore"] ? (
                            <div className="flex_col alignright_complete">
                              {teamB["teamBScore"][0] ? (
                                <h4 className="blueblacknew16 text_green ">
                                  {teamB["teamBScore"][0]}
                                </h4>
                              ) : (
                                  ""
                                )}
                              {teamB["teamBScore"][1] ? (
                                <h4 className="blueblacknew16 text_green ">
                                  {teamB["teamBScore"][1]}
                                </h4>
                              ) : (
                                  ""
                                )}
                            </div>
                          ) : (
                              ""
                            )}
                        </div>
                      </div>
                    </div>
                  )}

              </div>
            </div>
          </div>
        </div>
        {
          ((params['device'] == "pwa" && parseInt(params['version']) >= 14) || (params['device'] == "ios" && parseInt(params['version']) >= 302) || (params['device'] == "android" && parseInt(params['version']) >= 207)) ? <div className=" targrt_score_wrap">
           <div className="trg"> 
             {/* <h4 className="targrt_score">{this.state.testMatchStatus} </h4> */}
</div>
            <h4 className="tap_for_more" >tap for more</h4>
          </div> : ""
        }
      </div>
    );
  }
}
